import React from 'react';
import { FiBarChart2, FiX } from 'react-icons/fi';

const HighlightMetricsModal = ({ isOpen, onOpen, onClose, title = 'Highlight metrics', children }) => {
    return (
        <>
            <div className="flex justify-end">
                <button
                    type="button"
                    onClick={onOpen}
                    className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm transition hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-600"
                >
                    <FiBarChart2 size={16} />
                    View highlights
                </button>
            </div>

            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
                    <div className="w-full max-w-5xl rounded-2xl border border-slate-200 bg-white p-4 shadow-xl md:p-6">
                        <div className="flex items-center justify-between gap-3 border-b border-slate-200 pb-3">
                            <h2 className="text-lg font-semibold text-slate-800">{title}</h2>
                            <button
                                type="button"
                                onClick={onClose}
                                className="inline-flex items-center justify-center rounded-md p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
                                aria-label="Close highlight metrics"
                            >
                                <FiX size={20} />
                            </button>
                        </div>
                        <div className="mt-4 max-h-[70vh] overflow-auto">{children}</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HighlightMetricsModal;
